<template>
  <div class="cinemaApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="cinema-detail">
      <h2>{{setCinema.name}}</h2>
      <p>{{setCinema.address}}</p>

      <ul class="moviesList" v-if="setShowlist.length > 0">
        <li v-for="(item,i) in setShowlist" :class="moviesId == item.id ? 'on' : ''" @click="choose(item.id,i)">
          <el-image style="width: 100%; height: 80px" :src="item.logo" fit="cover"></el-image>
          <i class="el-icon-check"></i>
        </li>
      </ul>
      
      <div class="moviesTitle" v-if="setShowlist.length > 0">
        <h1>{{setInxData.name}} </h1>
        <div>
          <span v-if="setInxData.id > 0">{{setInxData.duration}}分钟/{{setInxData.type}}/{{setInxData.director}}</span>

          <span v-if="setInxData.length<= 0">请选择您需要观看的影片</span>
        </div>
      </div>
    </div>
    <div v-if="setShowlist.length <= 0" style="text-align:center;padding-top:120px;color:#666">该影院暂无影片播放</div>
    <div class="show-list" v-if="setShowlist.length > 0">
      <div class="tab">
        <div :class="dates == item ? 'item on' : 'item'" v-for="(item,i) in setInxData.playdateList" @click="chooseShow(i)" v-if="i<=5">{{item.substring(5)}}</div>
      </div>
      <ul>
        <li v-for="(item,i) in setInxData.playItemList" v-if="dates == (item.playTime).substring(0,10)">
          <div class="left first">
            <span v-if="item.playTime">{{(item.playTime).substring(11,16)}}</span>
            <span>{{item.showVersionType}}</span>
            <span>￥<font>{{item.price/100}}</font>元起</span>
          </div>
          <div class="left">
            <span v-if="item.closeTime">{{(item.closeTime).substring(11,16)}}散场</span>
            <span class="txtOut">{{item.hallName}}</span>
            <span style="color:#999;text-decoration:line-through"></span>
          </div>
          <a  @click="goSeats(item.playItemId)">购票</a>
        </li>
      </ul>
    </div>
  </div>
  
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        timestamp:0,
        setCinema:[],
        setMovies:[],
        inx:0,
        setShowlist:[],
        setShowdates:[],
        tabinx:0,
        dates:'',
        moviesId:'',
        distance:'',
        setInxData:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      var id = this.$route.query.id;
      var movie = this.$route.query.movie;
      //this.distance = this.$route.query.distance;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/cinema?id='+id+'&movie='+movie);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }
      this.moviesId = movie
    },
    mounted() {
      this.newDay();
      this.timestamp = Date.parse(new Date());
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.getShowList()
      }
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      newDay:function(){

        var dates = this.$route.query.dates;
        var day = new Date();
        day.setTime(day.getTime());
        var s = day.getFullYear()+"-" + ((day.getMonth()+1) <10 ? '0'+(day.getMonth()+1) : (day.getMonth()+1)) + "-" + (day.getDate() < 10 ? '0'+day.getDate() : day.getDate());
        this.dates = (dates == undefined ? s : dates);
      },
      goSeats:function(showId){
        this.$router.push({
          path:'seats',
          query:{
            id:showId
          }
        })
      },
      getLocalTime:function(nS) {
        var str = new Date(parseInt(nS)).toLocaleString();
        return str.substr(9, str.length - 12)    
      },
      choose:function(movieId,inx){
        this.inx = inx;
        this.moviesId = movieId
        this.setInxData = this.setShowlist[inx];
        //this.getShowList(movieId)
      },
      chooseShow:function(inx,datetime){
        this.tabinx = inx;
        this.dates = this.setShowlist[this.inx].playdateList[inx];
      },
      getShowList:function(){
        var that = this;
        var id = this.$route.query.id;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/movieDates',
          data:{
            movieId:id,
          },
          dataType:'json',
          success:function(data){
            that.setCinema = data.data.cinema;
            that.setShowlist = data.data.movieList;
            var movies = data.data.movieList;
            var mId = that.moviesId == '' ?  data.data.movieList[0].id : that.moviesId;
            if(that.moviesId == ''){
              that.moviesId = mId
            }
            for(var i=0;i<movies.length;i++){
              if(mId == movies[i].id){
                that.inx = i;
                that.setInxData = movies[i];
              }
            }
            that.fullscreenLoading = false;
          }
        })
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .cinemaApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }

  .cinemaApp .cinema-detail{
    background:#fff
  }
  .cinemaApp .cinema-detail h2{
    width:92%;
    margin:0 auto;
    font-size:18px;
    font-weight:bold;
    color:#333;
    padding-top:15px
  }
  .cinemaApp .cinema-detail p{
    width:92%;
    margin:0 auto;
    font-size:15px;
    color:#666;
    padding:10px 0
  }
  .cinemaApp .cinema-detail .moviesList{
    width:94%;
    margin:0 auto;
    display: grid;
    grid-template-columns: 18% 18% 18% 18% 18%;/*有几列，每列有多大*/
    grid-gap: 10px;
    background:#ebebeb;
    padding:15px 3%
  }
  .cinemaApp .cinema-detail .moviesList li{
    width:100%;
    position:relative;
    background:#fff;
    border-radius: 5px;
    font-size:0;
    padding:1px
  }
  .cinemaApp .cinema-detail .moviesList li.on{
    background:#f00
  }
  .cinemaApp .cinema-detail .moviesList li.on i{
    font-size:15px;
    position:absolute;
    top:0;
    color:#fff;
    left:0;
    background:rgba(255,0,0,0.8);
    padding:2px 5px;
    border-radius: 5px 0 5px 0;
  }
  .cinemaApp .cinema-detail .moviesList li .el-image img{
    border-radius: 5px;
  }
  .cinemaApp .cinema-detail .moviesTitle h1{
    text-align:center;
    font-size:16px;
    padding:15px 0 10px 0
  }
  .cinemaApp .cinema-detail .moviesTitle h1 span{
    font-weight:400;
    font-size:13px;
    color:#666;
    padding-left:5px;
  }
  .cinemaApp .cinema-detail .moviesTitle h1 span font{
    font-weight:bold;
    color:#F8A927;
  }
  .cinemaApp .cinema-detail .moviesTitle div{
    text-align:center;
    font-size:14px;
    color:#666;
    padding-bottom:15px;
  }
  .cinemaApp .cinema-detail .moviesTitle div span{
  }
  .cinemaApp .cinema-detail .moviesTitle div span:last-child{
    border:0
  }

  .cinemaApp .show-list{
    padding-bottom:15px
  }
  .cinemaApp .show-list .tab{
    display: flex;
    flex-wrap: nowrap;
    height:45px;
    background:#fff;
    width:calc(100% - 15px);
    margin-top:1px;
    padding-left:15px
  }
  .cinemaApp .show-list .tab .item{
    height:45px;
    line-height:45px;
    font-size:14px;
    color:#666;
    text-align:center;
    margin-right:20px
  }
  .cinemaApp .show-list .tab .on{
    position:relative;
    color:#000;
    font-weight:bold;
  }
  .cinemaApp .show-list .tab .on:after{
    position:absolute;
    content:'';
    bottom:6px;
    background: linear-gradient(-90deg, #FE506A, #FE5CA3);
    width:25px;
    height:4px;
    left:50%;
    transform: translateX(-50%);
    border-radius: 5px;
  }

  .cinemaApp .show-list ul{
    width:93%;
    margin:0 auto;
  }
  .cinemaApp .show-list ul li{
    width:100%;
    background:#fff;
    border-radius: 5px;
    padding:10px 0;
    position:relative;
    margin-top:15px
  }

  .cinemaApp .show-list ul li .left{
    width:81%;
    margin-left:8px
  }
  .cinemaApp .show-list ul li .left span{
    padding-right:20px;
    font-size:14px;
    color:#666;
  }
  .cinemaApp .show-list ul li .left .txtOut{
    display:inline-block;
    width:85px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: bottom;
  }
  .cinemaApp .show-list ul li .first{
    padding-bottom:10px
  }
  .cinemaApp .show-list ul li .first span{
    color:#000;
  }
  .cinemaApp .show-list ul li .first span:first-child{
    font-weight:bold;
    font-size:16px;
    display:inline-block;
    width:62px
  }
  .cinemaApp .show-list ul li .left span:last-child{
    float:right;
    color:#FE506A
  }
  .cinemaApp .show-list ul li .left span:last-child font{
    font-weight:bold;
  }
  .cinemaApp .show-list ul li a{
    position:absolute;
    background: linear-gradient(90deg, #FE506A, #FE5CA3);
    top:50%;
    transform: translateY(-50%);
    color:#fff;
    font-size:14px;
    width:60px;
    right:2%;
    height:30px;
    border-radius: 30px;
    text-align:center;
    line-height:30px;
  }
</style>